import { render } from "./FooterCopyrightSSK.vue?vue&type=template&id=dce099d0"
import script from "./FooterCopyrightSSK.vue?vue&type=script&lang=js"
export * from "./FooterCopyrightSSK.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__